export default {
  Title: 'Leads Loom',
  Header: {
    Summary: 'Last updated: #{updatedTime}',
  },
  Card: {
    Subtitles: {
      Caregivers: 'Caregivers',
      Created: 'Created',
      DaysInStage: 'Days in stage',
      InStage: 'In stage: #{value}',
      Location: 'Location',
    },
    SubtitleValue: {
      Day: '#{number} day',
      Days: '#{number} days',
      NotSet: 'Not set',
    },
  },
  Filter: {
    Search: 'Search',
    SearchPlaceholder: 'Name or Contact',
    Status: 'Status',
    MoreFilters: 'More filters',
  },
};
